import type {DalValue, ComponentWithResolvedDataItems, SchemaService, VariantSplit} from '@wix/document-services-types'
import {VARIANTS_DATA_TYPES} from '@wix/format-converter-schemas'
import _ from 'lodash'
import {REF_ARRAY_DATA_TYPE} from '../../constants'
import type {SingleComponentPluginFunction} from '../../types'
import {
    type ReferredDataItemsIterateeContext,
    type VariantRelationPossiblySerialized,
    forEachReferredDataItem
} from '@wix/import-export-utils'

const VARIANT_RELATION_DATA_TYPE = 'VariantRelation'

export const convertDataItemToVariantSplit = (item: DalValue): VariantSplit => {
    if (item.type !== REF_ARRAY_DATA_TYPE) {
        return {default: item}
    }

    const [defaultValues, variants] = _.partition(item.values, ref => ref.type !== VARIANT_RELATION_DATA_TYPE)

    const variantSplit: VariantSplit = {
        variants: variants.map((variant: VariantRelationPossiblySerialized) => ({
            value: variant.to,
            conditions: variant.variants
        }))
    }

    const defaultValue = defaultValues[0]
    if (defaultValue) {
        variantSplit.default = defaultValues[0]
    }

    return variantSplit
}

export const pack: SingleComponentPluginFunction = (
    component: ComponentWithResolvedDataItems,
    schemaService: SchemaService
): void => {
    _.forOwn(VARIANTS_DATA_TYPES, (namespace: string) => {
        const componentData = component.data
        const featureData = componentData[namespace]
        if (!featureData) {
            return
        }

        forEachReferredDataItem(
            schemaService,
            featureData,
            namespace,
            ({item, itemRefInfo, ownerItem = componentData}: ReferredDataItemsIterateeContext) => {
                if (itemRefInfo.isRelationalSplit) {
                    _.set(ownerItem, itemRefInfo.path, convertDataItemToVariantSplit(item))
                }
            }
        )
    })
}
